module.exports = __webpack_public_path__ + "media/images/homepage/reason-2-94a99772fd609aa85a64efa3d516a121.png";